import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const ExpertWitnessDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedExpertWitness, refreshData }) => {
    const initialExpertWitnessData = {
        id: '',
        fullName: '',
    };

    const validationSchema = useMemo(() => ({
        fullName: {
            required: true,
            message: 'Ad Soyad zorunludur.',
            minLength: 2,
            minLengthMessage: 'Ad Soyad en az 2 karakter olmalıdır.',
            minWords: 2,
            minWordsMessage: 'En az iki kelime girmelisiniz.',
        },
    }), []);

    const {
        formData: expertWitnessData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedExpertWitness,
        initialData: initialExpertWitnessData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            selectedItem: mode === 'modify' ? { id: selectedExpertWitness?.id } : null,
            refreshData,
            componentName: 'Bilirkişi',
            buildPayload: (data) => ({
                fullName: data.fullName.trim(),
                ...(mode === 'modify' && selectedExpertWitness?.id && { id: selectedExpertWitness.id }),
            }),
        },
    });

    const getModalTitle = () => {
        return mode === 'add' ? 'Bilirkişi Ekle' : 'Bilirkişi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="fullName">Ad Soyad <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={expertWitnessData.fullName || ''}
                            onChange={handleInputChange}
                            placeholder="Bilirkişi Ad Soyad"
                            invalid={!!errors.fullName}
                        />
                        <FormFeedback>{errors.fullName}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </Button>
                <Button color="outline-danger" onClick={handleCancel} className="ms-2 rounded-pill">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

ExpertWitnessDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedExpertWitness: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default ExpertWitnessDataModal;
